import { useMemo } from 'react';
import { useGetAllExternalServiceLogosQuery } from '../graphql/types';
import { AppConfig } from '../config';

export function useExternalServiceLogo(serviceConfig?: { type: string; logo?: string } | null) {
  const { data } = useGetAllExternalServiceLogosQuery();

  return useMemo(() => {
    if (!serviceConfig) return null;

    const logoMapping: Record<string, string> = data?.getAllExternalServiceLogos || {};
    const defaultLogoFile = logoMapping[serviceConfig.type];

    if (!serviceConfig.logo || serviceConfig.logo === defaultLogoFile || serviceConfig.logo === undefined) {
      return `${AppConfig.apiRoot}files/image-asset/${defaultLogoFile}`;
    }

    return `${AppConfig.apiRoot}files/avatar/${serviceConfig.logo}`;
  }, [serviceConfig, data]);
}
